import { Box, Grid } from "@mui/material";
import { getBillingEntity } from "api/services/billingEntity";
import EmptyPage from "components/EmptyPage";
import FloatingButton from "components/FloatingButton";
import Loader from "components/Loader";
import SearchContainer from "components/SearchContainer";
import { snack } from "components/toast";
import useFilteredData from "hooks/useFilteredData";
import useTitle from "hooks/useTitle";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useSearchParams } from "react-router-dom";
import { ResType } from "types";
import AddBillingEntity from "views/settings/organization/BillingEntities/AddBillingEntity";
import BillingEntityCard from "./BillingEntityCard";

const BillingEntities = () => {
  useTitle("BillingEntity");
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState<boolean>(false);
  const [searchParams] = useSearchParams();

  // Lets other pages (e.g. Settings > Onboarding) link straight into this
  // page with the add-entity drawer already open, via a ?import=1 query param.
  useEffect(() => {
    if (searchParams.get("import") === "1") {
      setOpen(true);
    }
  }, [searchParams]);

  const { data, isLoading }: ResType = useQuery(["billing-entities"], getBillingEntity, {
    onError: (err: any) => {
      if (!err?.error) {
        snack.error(`An error occurred while fetching billing entities data`);
      }
    }
  });
  const filteredData = useFilteredData(data?.data, ["legalName"], search)?.slice()?.sort((a: any, b: any) =>
    (a?.tradeName || "").localeCompare(b?.tradeName || "")
  );

  if (isLoading) return <Loader />;

  if (!data?.data?.length) {
    return (
      <>
        <EmptyPage
          title="There are no Billing Entities"
          btn2Title="Add New Billing Entity"
          btn2Action={() => setOpen(true)}
          desc="Click on Add New Billing Entity to add a Billing Entity"
        />
        <AddBillingEntity open={open} setOpen={setOpen} />
      </>
    );
  }

  return (
    <Box p={2} pb={0} px={1}>
      {/* <Box px={2} width={'100%'} >
        <SearchContainer onChange={setSearch} />
      </Box> */}
      <Grid container spacing={2}>
        {filteredData?.map((item: any, index: any) => (
          <Grid item xs={10} md={4} key={index}>
            <BillingEntityCard data={item} />
          </Grid>
        ))}
      </Grid>
      {data?.data?.length < 10 && <FloatingButton onClick={() => setOpen(true)} />}
      <AddBillingEntity open={open} setOpen={setOpen} />
    </Box>
  );
};

export default BillingEntities;
